<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('account.password.change') }}</h3>
        </div>

        <div class="password-requirement">
            <p>{{ $t('account.password.requirement') }}</p>
            <ul>
                <li>{{ $t('account.password.rule1') }}</li>
                <li>{{ $t('account.password.rule2') }}</li>
                <li>{{ $t('account.password.rule3') }}</li>
                <li>{{ $t('account.password.rule4') }}</li>
            </ul>
        </div>

        <form @submit.prevent="handleOnSubmit">
            <div class="form-group row">
                <label for="password" class="col-sm-4 col-form-label">{{ $t('account.edit.currentPassword') }}</label>
                <div class="col-sm-8">
                    <input v-model="formData.password" type="password" id="password" name="password"
                           class="form-control"
                           v-bind:class="{ 'is-invalid': errors.password}"/>
                    <div v-if="errors.password" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.password) }}</div>
                </div>
                <div v-if="(!errors.password)" class="invalid-errors-hiddens"></div>
            </div>

            <div class="form-group row">
                <label for="new_password" class="col-sm-4 col-form-label">{{ $t('account.edit.password') }}</label>
                <div class="col-sm-8">
                    <input v-model="formData.new_password" type="password" id="new_password" name="new_password"
                           class="form-control"
                           v-bind:class="{ 'is-invalid': errors.new_password}"/>
                    <div v-if="errors.new_password" class="invalid-feedback invalid-errors">{{ $t('errors.' + errors.new_password) }}</div>
                </div>
                <div v-if="(!errors.new_password)" class="invalid-errors-hiddens"></div>
            </div>

            <div class="form-group row">
                <label for="new_password_confirmation" class="col-sm-4 col-form-label">{{ $t('account.edit.passwordAgain')
                    }}</label>
                <div class="col-sm-8">
                    <input v-model="formData.new_password_confirmation" type="password" id="new_password_confirmation"
                           name="new_password_confirmation"
                           class="form-control"
                           v-bind:class="{ 'is-invalid': errors.new_password_confirmation}"/>
                    <div v-if="errors.new_password_confirmation" class="invalid-feedback invalid-errors">{{ $t('errors.' +errors.new_password_confirmation) }}</div>
                </div>
                <div v-if="(!errors.new_password_confirmation)" class="invalid-errors-hiddens"></div>
            </div>

            <div class="text-center btn-position">
                <div class="pb-4 ">
                    <button type="submit" :disabled="submitBtnDisabled()" class="btn btn-primary">{{ $t('account.edit.submit') }}</button>
                </div>
            </div>

            <div>

            </div>
        </form>
    </div>
</template>

<script>
    import userService from '../../services/UserService';

    export default {
        name: 'reset-password',

        data() {
            return {
                errors: this.getDefaultFields(),
                formData: this.getDefaultFields(),
                submitted: false,
            }
        },

        mounted() {
        },

        created() {
            this.fetchUserFrontendData()
        },

        methods: {
            getDefaultFields() {
                return {
                    password: '',
                    new_password: '',
                    new_password_confirmation: '',
                };
            },
            async fetchUserFrontendData() {
                const data = (await userService.getUserFrontendData()).data;
                this.latestMembershipFee = data.latestMembershipFee;

                this.isChild = data.is_child;

            },

            submitBtnDisabled() {
                return this.submitted;
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();

                try {
                    this.submitted = true;
                    await userService.resetPassword({
                        ...this.formData
                    });
                    if(!this.isChild){
                        this.$router.push('/account/reset-password-complete');
                    }else{
                        this.$router.push('/child/reset-password-complete');
                    }
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                } finally {
                    this.submitted = false;
                }
            }
        }
    }
</script>

<style scoped>
    .password-requirement {
        margin: 40px 0px 40px 0px; 
    }
    .password-requirement p {
        margin-bottom: 1em;
    }
    .password-requirement ul {
        list-style: disc;
    }
    .password-requirement ul li {
        margin-left: 3.5em;
    }
    .form-group{
        margin: 0px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }
    /*PC PAD用css*/
    @media screen and (min-width: 479px) { /*ウィンドウ幅が479px以上の場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 77px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:40px;
            height:auto !important;
            height:40px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
    }
    /*スマホ用css*/
    @media screen and (max-width: 479px) { /*ウィンドウ幅が最大479pxまでの場合に適用*/
        .invalid-errors-hiddens{
            visibility:hidden;
            height: 52px;
            margin-top: 4px;
            margin-bottom: 4px;
        }
        .invalid-errors{
            min-height:10px;
            height:auto !important;
            height:10px;
            margin-top: 5px;
        }
        .col-form-label{
            padding-top: 0px;
        }
        .btn-position{
            padding-top: 10px;
        }
    }
</style>
